<template>
    <div class="ppv2-font-sans ppv2-text-[#2d3748]">
        <div class="ppv2-mb-4">
            <div class="ppv2-relative">
                <BaseSelect
                    :label="resolvedSelectLabel"
                    :options="items"
                    option-label="label"
                    :option-value="optionValue"
                    v-model="selectedId"
                    :placeholder="$t('widgetIntegration.chooseActivity')"
                />
            </div>
        </div>
        <div
            v-if="showActions"
            class="ppv2-bg-purple ppv2-bg-opacity-[13%] ppv2-border ppv2-border-dashed border-purple ppv2-rounded-2xl ppv2-p-5"
        >
            <h3 class="ppv2-text-sm poppinsSemiBold ppv2-text-black ppv2-opacity-80 ppv2-mb-3 ppv2-block">
                {{ $t('widgetIntegration.needChange') }}
            </h3>
            <div class="ppv2-space-y-3">
                <a
                    v-if="editHref"
                    target="_blank"
                    :href="editHref"
                    class="ppv2-flex ppv2-items-center ppv2-gap-[10px] ppv2-border-none ppv2-bg-transparent ppv2-cursor-pointer ppv2-p-0 ppv2-font-inherit text-purple ppv2-text-opacity-80 hover:ppv2-text-opacity-100 ppv2-text-sm poppinsMedium ppv2-underline ppv2-underline-offset-[3px]"
                >
                    <Pencil :size="17" />
                    <span>{{ resolvedEditLabel }}</span>
                </a>
                <a
                    v-if="createHref"
                    target="_blank"
                    :href="createHref"
                    class="ppv2-flex ppv2-items-center ppv2-gap-[10px] ppv2-border-none ppv2-bg-transparent ppv2-cursor-pointer ppv2-p-0 ppv2-font-inherit text-purple ppv2-text-opacity-80 hover:ppv2-text-opacity-100 ppv2-text-sm poppinsMedium ppv2-underline ppv2-underline-offset-[3px]"
                >
                    <Plus :size="17" />
                    <span>{{ resolvedCreateLabel }}</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import BaseSelect from '../../Shared/BaseSelect.vue'
import { Pencil, Plus } from 'lucide-vue'
export default {
    name: 'WidgetEntitySelector',
    components: { BaseSelect, Pencil, Plus },
    props: {
        items: { type: Array, default: () => [] },
        optionValue: { type: String, default: 'originalId' },
        selectLabel: { type: String, default: '' },
        editPath: { type: String, default: null },
        createPath: { type: String, default: null },
        editLabel: { type: String, default: '' },
        createLabel: { type: String, default: '' },
        showActions: { type: Boolean, default: true },
    },
    emits: ['selected'],
    data() {
        return { selectedId: null }
    },
    computed: {
        baseUrl() {
            return window.location.origin
        },
        resolvedSelectLabel() {
            return this.selectLabel || this.$t('widgetIntegration.noSelection')
        },
        resolvedEditLabel() {
            return this.editLabel || this.$t('widgetIntegration.modify')
        },
        resolvedCreateLabel() {
            return this.createLabel || this.$t('widgetIntegration.create')
        },
        editHref() {
            if (!this.editPath || !this.selectedId) return null
            return this.baseUrl + this.editPath.replace('{id}', this.selectedId)
        },
        createHref() {
            if (!this.createPath) return null
            return this.baseUrl + this.createPath
        },
    },
    watch: {
        selectedId(val) {
            this.$emit('selected', val)
        },
        items: {
            immediate: true,
            handler(val) {
                if (val.length > 0 && !this.selectedId) {
                    this.selectedId = val[0][this.optionValue]
                }
            },
        },
    },
}
</script>
